export default __webpack_public_path__ + "static/media/6.cc0fa023.png";